/*=========================================================================================
  File Name: module-auth.js
  Description: Auth Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from "./module-context-state";
import mutations from "./module-context-mutations";
import actions from "./module-context-actions";
import getters from "./module-context-getters";

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
